import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ComposerInputGroupSizeMap,
    ComposerDynamicStyleType,
    ComposerHintIcon
} from "./type";
import {
    ComposerWifiOffIcon,
    ComposerInfoIcon
} from "./components/icons";
import type {
    NCoreUIKitIcon,
    Mutable
} from "../../types";
import {
    getCornerStyle
} from "../../helpers/theme/corner";

export const COMPOSER_INPUT_GROUP_SIZES: ComposerInputGroupSizeMap = {
    medium: "medium",
    large: "large"
};

export const COMPOSER_HINT_ICONS: Record<ComposerHintIcon, NCoreUIKitIcon> = {
    offline: ComposerWifiOffIcon,
    info: ComposerInfoIcon
};

export const COMPOSER_COUNTER_RATIO = 0.9;

const stylesheet = StyleSheet.create({
    dropLayer: {
        ...StyleSheet.absoluteFill,
        justifyContent: "center",
        borderStyle: "dashed",
        pointerEvents: "none",
        flexDirection: "row",
        alignItems: "center"
    },
    container: {
        position: "relative",
        minWidth: 0
    },
    keyboardHint: {
        position: "absolute",
        overflow: "hidden",
        opacity: 0,
        height: 1,
        width: 1
    },
    stretchedContainer: {
        width: "100%"
    },
    attachments: {
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    isWidthControlled,
    shapeConfigs,
    radiuses,
    borders,
    spaces,
    colors
}: ComposerDynamicStyleType) => {
    const styles = {
        dropLayer: {
            backgroundColor: colors.content.container.raised,
            borderColor: colors.content.border.default,
            zIndex: shapeConfigs.layers.raised + 1,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            }),
            borderWidth: borders.line,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        container: {} as Mutable<ViewStyle>
    };

    if(!isWidthControlled) {
        Object.assign(styles.container, stylesheet.stretchedContainer);
    }

    return styles;
};
export default stylesheet;
